<template>
  <div class="flex items-center text-xs">
    <svg class="w-[18px] mr-3" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5535 10.5622V8.36684C15.5535 8.18076 15.4812 8.00231 15.3525 7.87074C15.2238 7.73916 15.0492 7.66525 14.8672 7.66525H9.20734C8.99726 7.66525 8.79024 7.61377 8.60363 7.51513C8.41702 7.41649 8.25627 7.27356 8.13484 7.09831L7.415 6.0595C7.29357 5.88425 7.13282 5.74132 6.94621 5.64268C6.7596 5.54403 6.55258 5.49255 6.3425 5.49255H3.13287C2.95084 5.49255 2.77627 5.56647 2.64756 5.69805C2.51884 5.82962 2.44653 6.00807 2.44653 6.19415V10.5622H15.5535Z"
        fill="white" />
      <path
        d="M14.9654 16.8086H3.03464C2.86359 16.8086 2.69691 16.7534 2.55839 16.6508C2.41987 16.5482 2.31659 16.4035 2.2633 16.2374L0.92992 12.0802C0.900768 11.9893 0.893104 11.8926 0.907557 11.7981C0.92201 11.7036 0.958167 11.614 1.01307 11.5365C1.06796 11.4591 1.14004 11.396 1.22338 11.3525C1.30672 11.309 1.39896 11.2864 1.49253 11.2864H16.5075C16.6011 11.2864 16.6933 11.309 16.7766 11.3525C16.86 11.396 16.9321 11.4591 16.987 11.5365C17.0419 11.614 17.078 11.7036 17.0925 11.7981C17.1069 11.8926 17.0993 11.9893 17.0701 12.0802L15.7367 16.2374C15.6834 16.4035 15.5802 16.5482 15.4416 16.6508C15.3031 16.7534 15.1364 16.8086 14.9654 16.8086Z"
        fill="white" />
      <path
        d="M11.2925 2.86427C11.9568 2.18519 12.8578 1.80369 13.7973 1.80369C14.7368 1.80369 15.6378 2.18519 16.3021 2.86425C16.6113 3.18283 16.8795 3.54051 17.1 3.9286L16.8782 3.70187C15.7353 2.53356 13.5685 2.85426 12.4256 4.02256L13.6709 5.29546L10.0473 5.29545V1.59137L11.2925 2.86427Z"
        fill="white" />
    </svg>
    {{ Storage }}
    <a @click.prevent="" :title="$e('Média en cours de transfert')" v-if="MediaTransfert">
      <svg class="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
        </path>
      </svg>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    Storage() {
      return (
        this.config?.dock?.status?.storage?.used != undefined &&
        this.config?.dock?.status?.storage?.total != undefined
      )
        ? (this.config.dock.status.storage.used / 1000000).toFixed(2) + " / " + (this.config.dock.status.storage.total / 1000000).toFixed(2) + " GB"
        : ENV.NO_DATA;
    },
    MediaTransfert() {
      return this.config.dock?.media_file_detail?.remain_upload != undefined && this.config.dock?.media_file_detail?.remain_upload > 0;
    },
  },
};
</script>
